import { TPrevPortalMode } from '@/src/providers';

const portalSeeAllLabels: Partial<Record<TPrevPortalMode, string>> = {
  main: 'Витрина',
  seeAll: 'See all',
  menu: 'Меню',
};

export const getSource = (mode: TPrevPortalMode): string | null => {
  if (!mode) {
    return null;
  }
  return portalSeeAllLabels[mode] ?? null;
};
